import { useState, useEffect } from "react";

import { FaCog, FaUser, FaDoorOpen, FaCar, FaChartPie } from "react-icons/fa";
import { MdQrCodeScanner } from "react-icons/md";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";



const monthNames = [
  "Jan",
  "Fév",
  "Mar",
  "Avr",
  "Mai",
  "Juin",
  "Juil",
  "Août",
  "Sep",
  "Oct",
  "Nov",
  "Déc",
];

export default function Statistiques() {
  const API_BASE = "https://srv968119.hstgr.cloud";
  const [avisTotal, setAvisTotal] = useState(0);
  const [avisTraites, setAvisTraites] = useState(0);

  const [time, setTime] = useState(new Date());
  const [vehicleStats, setVehicleStats] = useState([]);
  const [checkStats, setCheckStats] = useState({
    total: 0,
    today: 0,
    last30Days: 0,
  });
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());




  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const avisRes = await axios.get(`${API_BASE}/statistique/avis/stats`);
        setAvisTotal(avisRes.data.totalAvis);
        setAvisTraites(avisRes.data.avisTraites);
        // Récupérer les stats des Etiquettes
        const vehiclesRes = await axios.get(
          `${API_BASE}/statistique/vehicules/stats?year=${selectedYear}`
        );
        const formattedData = vehiclesRes.data.map((item) => ({
          name: monthNames[item.month - 1],
          count: item.count,
        }));
        setVehicleStats(formattedData);

        // Récupérer les stats des checks
        const checksRes = await axios.get(
          `${API_BASE}/statistique/checks/stats`
        );
        setCheckStats(checksRes.data);
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [selectedYear]);

  return (
    <div className="w-[80%] h-[80%] flex flex-col items-center text-gray-400 absolute mt-[4%] ml-[10%] p-9">
      {/* Statistiques en haut */}
      <div className="bg-transparent m-1 h-full flex flex-row  p-2 w-full">
        <div className="stat place-items-center">
          <div className="stat-title font-bold">Etiquettes créés</div>
          <div className="stat-value">
            {vehicleStats.reduce((sum, item) => sum + Number(item.count), 0)}
          </div>
          <div className="stat-desc">en {selectedYear}</div>
        </div>

        <div className="stat place-items-center">
          <div className="stat-title font-bold">Contrôles totaux</div>
          <div className="stat-value">{checkStats.total}</div>
          <div className="stat-desc">depuis le début</div>
        </div>

        <div className="stat place-items-center">
          <div className="stat-title font-bold">Contrôles aujourd'hui</div>
          <div className="stat-value text-secondary">{checkStats.today}</div>
          <div className="stat-desc text-secondary"></div>
        </div>

        <div className="stat place-items-center">
          <div className="stat-title font-bold">30 derniers jours</div>
          <div className="stat-value">{checkStats.last30Days}</div>
          <div className="stat-desc"></div>
        </div>

        <div className="stat place-items-center">
  <div className="stat-title font-bold">Avis totaux</div>
  <div className="stat-value">{avisTotal}</div>
  <div className="stat-desc">avis créés</div>
</div>

<div className="stat place-items-center">
  <div className="stat-title font-bold">Avis traités</div>
  <div className="stat-value text-green-400">{avisTraites}</div>
  <div className="stat-desc">validés</div>
</div>
      </div>

      {/* Graphique des Etiquettes créés */}

      {/* Menu */}


      <div className="w-full h-96 bg-white bg-opacity-10 rounded-lg p-4 mb-8 mt-20">
  <div className="flex justify-between items-center mb-4">
    <h2 className="text-xl font-bold">Création de Etiquettes par mois</h2>
    <select
      className="bg-gray-700 text-gray-400 p-2 rounded"
      value={selectedYear}
      onChange={(e) => setSelectedYear(Number(e.target.value))}
    >
      {Array.from(
        { length: new Date().getFullYear() - 2021 + 1 },
        (_, i) => {
          const year = 2022 + i;
          return (
            <option key={year} value={year}>
              {year}
            </option>
          );
        }
      )}
    </select>
  </div>

  {loading ? (
    <div className="flex justify-center items-center h-full">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
    </div>
  ) : (
    <ResponsiveContainer width="100%" height="90%">
      <LineChart
        data={vehicleStats}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#4b5563" />
        <XAxis
          dataKey="name"
          stroke="#e5e7eb"
        />
        <YAxis
          stroke="#e5e7eb"
          domain={[0, (dataMax) => Math.max(dataMax * 1.1, 7000)]} // Marge de 10% avec minimum 1000
          tickFormatter={(value) => value.toLocaleString()} // Formatage avec séparateurs de milliers
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "#1f2937",
            borderColor: "#4b5563",
          }}
          formatter={(value) => [`${value.toLocaleString()} Etiquettes`, "Nombre"]}
          labelFormatter={(label) => `Mois: ${label}`}
        />
        <Legend />
        <Line
          type="monotone"
          dataKey="count"
          stroke="#10b981"
          strokeWidth={3} // Épaisseur augmentée
          dot={{ r: 5 }}
          activeDot={{ r: 8, strokeWidth: 2 }}
          name="Etiquettes créés"
        />
      </LineChart>
    </ResponsiveContainer>
  )}
</div>
    </div>
  );
}
